export default __webpack_public_path__ + "static/media/Logo.3bf44880.png";